<template>
  <el-dialog title="请选择"
              :visible.sync="memberDialog.dialogVisible"
              custom-class="member-dialog"
              center append-to-body
              :before-close="dialogClose"
              :close-on-click-modal="false"
              @open="open()"
              width="508px">
      <div class="member-dialog-content">
          <div class="left">
              <div class="search">
                  <el-input prefix-icon="el-icon-search"
                            v-model="memberDialog.filterText"
                            placeholder="搜索人员">
                  </el-input>
              </div>
              <el-tree
                      :data="data" node-key="id" ref="tree"
                      :filter-node-method="filterNode"
                      :check-on-click-node="true"
                      :default-expanded-keys="firstLevelId"
                      icon-class="el-icon-folder-add"
                      :check-strictly="true"
                      @node-click="checkChange">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span><i :class="node.icon"></i>{{ data.name }}</span>
                    <template v-if="data.type==='user'">
                          <i v-show="data.flag===true" style="color: #54ABF1" class="el-icon-check"></i>
                    </template>
                  </span>
              </el-tree>
          </div>
          <div class="right">
              <div class="title"><span>已选择的成员</span></div>
              <div class="person">
                  <p v-for="(selected, index) in memberDialog.selectedList" :key="index">
                      <span>{{selected[defaultProps.label]}}</span>
                      <i class="el-icon-error remove-select" @click="removeSeleted(selected.id)"></i>
                  </p>
              </div>
          </div>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="memberConfirm">确 定</el-button>
          <el-button @click="dialogClose">取 消</el-button>
      </div>
  </el-dialog>
</template>
<script>
import cache from '../../public/cache'
export default {
  name: 'select-people-tree',
  props: ['value', 'memberDialog'],
  data () {
    return {
      radio: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      memberData: [],
      initData: [],
      firstLevelId: []
    }
  },
  created () {
    this.getPrincipal()
  },
  methods: {
    open () {
      if (this.value && typeof this.value === 'string') {
        this.initData = this.value.split(',')
      } else {
        this.initData = []
      }
      this.memberDialog.filterText = ''
      this.getPrincipal()
    },
    checkChange (data, checked) {
      if (data.type === 'user') {
        data.flag = !data.flag
        let index = this.memberDialog.selectedList.findIndex(m => m.id === data.id)
        if (index === -1) {
          this.memberDialog.selectedList.push({'id': data.id, 'name': data.name, 'type': data.type})
        } else {
          this.memberDialog.selectedList.splice(index, 1)
        }
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    getPrincipal () {
      cache.getData(`/auth-api/organization/getUserTree`).then(data => {
        data = data || []
        this.memberData = this.recursion(data)
        this.firstLevelId = this.memberData[0] ? [this.memberData[0].id] : []
        this.data = this.memberData
        this.$forceUpdate()
      })
    },
    recursion (arr) {
      arr.forEach(n => {
        if (n.type === 'user') {
          n.flag = false
          let index = this.initData.indexOf(n.id)
          if (index !== -1) {
            n.flag = true
            this.memberDialog.selectedList[index] = {'id': n.id, 'name': n.name, 'type': n.type}
          }
        }
        if (n.children.length) {
          this.recursion(n.children)
        }
      })
      return arr
    },
    removeSeleted (id) {
      let index = this.memberDialog.selectedList.findIndex(m => m.id === id)
      if (index > -1) {
        this.memberDialog.selectedList.splice(index, 1)
        // 树中选中的勾选的值的取消
        this.$refs.tree.setCheckedKeys([])
        let checkedKeys = []
        this.memberDialog.selectedList.forEach(m => {
          checkedKeys.push(m.id)
        })
        this.$refs.tree.setCheckedKeys(checkedKeys)
        this.removeNode(id, this.data)
      }
    },
    removeNode (id, arr) {
      arr.forEach(n => {
        if (n.type === 'user' && n.id === id) {
          n.flag = false
        } else if (n.children.length) {
          this.removeNode(id, n.children)
        }
      })
    },
    memberConfirm () {
      this.$emit('saveSuper', this.memberDialog.selectedList)
    },
    dialogClose () {
      this.$refs.tree.$children[0].node.parent.childNodes[0].expanded = false
      this.memberDialog.dialogVisible = false
    }
  },
  watch: {
    'memberDialog.filterText' (val) {
      this.$refs.tree.filter(val)
    }
  }
}
</script>
<style lang="scss">
.member-dialog {
    .el-dialog__body {
      padding: 12px 10px 0;

      .member-dialog-content {
        display: flex;
        border-radius: 5px;
        width: 100%;
        height: 366px;
        box-sizing: border-box;
        padding: 13px 0;
        border: 1px solid #dddddd;

        .left {
          width: 50%;
          height: 100%;
          padding: 0 13px;
          .el-tree{
            height: 310px;
            overflow: auto;
          }
          .el-tree-node__content{
            font-size: 14px;
            >.el-tree-node__expand-icon {
              padding: 5px;
            }
            .expanded{
              transform: rotate(0deg)
            }
            .expanded:before{
              content: "\e781";
            }
          }
        }

        .right {
          width: 50%;
          height: 100%;
          border-left: 1px solid #ddd;
          .title {
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 12px;
          }

          .person {
            height: 310px;
            overflow-y: auto;
            p {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 26px;
              line-height: 26px;
              padding: 0 13px;

              .remove-select {
                color: #CBCBCB;
              }
              .remove-select:active {
                color: red;
              }
            }

            p:nth-child(odd) {
              background-color: #ECF5FB;
            }

            p:hover {
              .remove-select {
                color: #fb9391;
              }
            }
            p:active {
              .remove-select {
                color: red;
              }
            }
          }
        }

        .custom-tree-node {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }

    .el-dialog__footer {
      padding: 15px;

      .dialog-footer {
        text-align: center;

        .el-button {
          width: 80px;
        }

        .el-button + .el-button {
          margin-left: 50px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/users/select-people-tree.vue